import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WfMdActionTypeContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

// https://api.akaun.cloud/core2/tnt/dm/wf/md/action-types

@Injectable({ providedIn: "root" })
export class WfMdActionTypeService extends BaseApiTemplateService<WfMdActionTypeContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/action-types";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + "md/action-types";
    this.httpClient = http;
  }
}
